import React, { useState, useCallback, useEffect, useMemo } from 'react';
// import { getUserinfo } from '@shakkerai/business-userinfo';
import { clearUsertokenToCookie, setCookieLongTerm } from '@shakkerai/util-cookie';
import { ShakkerLogin } from './components/ShakkerLogin';
import { LibLogin } from './components/LibLogin';
import { initUserInfo } from '@shakkerai/pro-store';
import { loginShakkerCallBack } from '@shakkerai/services';
import { config } from '@shakkerai/config';

export const useLoginStateHooks = () => {
  const [userInfo, setUserInfo] = useState();
  const [loginStatus, setLoginStatus] = useState('');

  // const loadLoginState = useCallback(() => {
  //   getUserinfo(true).then((res) => {
  //     setLoginStatus(res?.status);
  //     setUserInfo(res?.data);
  //   });
  // }, []);

  useEffect(() => {
    const fetchUserInfo = async () => {
      const data = await initUserInfo(true);
      setLoginStatus('done');
      setUserInfo(data?.userInfo);
    };
    fetchUserInfo();
  }, []);

  const [loginModalVisible, setLoginModalVisible] = useState();

  useEffect(() => {
    const onmessage = (event) => {
      if (event.data && typeof event.data == 'string' && event.data.indexOf('webpackHot') == -1) {
        let parsedData = {};
        try {
          parsedData = JSON.parse(event.data) || {};
        } catch (e) {
          console.log('postMessage data parsed failed:' + e);
          return;
        }

        const { type, token, data } = parsedData;

        if (type === 'loginSuccess') {
          console.log(`[DEBUG] parsedData:`, parsedData);
          setCookieLongTerm('usertoken', token || data);
          // loadLoginState();
          // setLoginModalVisible(false);
          setTimeout(() => {
            loginShakkerCallBack();
            window.location.reload();
          }, 0);
        } else if (type === 'onPageColse') {
          setLoginModalVisible(false);
        } else if (type === 'redirectUrl') {
          window.location = data;
        }
      }
    };

    window.addEventListener('message', onmessage);

    return () => {
      window.removeEventListener('message', onmessage);
    };
  }, []);

  const LoginModal = useMemo(() => {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: loginModalVisible ? 1000 : -1,
        }}
      >
        {config.env === 'aws' ? (
          <ShakkerLogin visible={loginModalVisible}> </ShakkerLogin>
        ) : (
          <LibLogin visible={loginModalVisible}></LibLogin>
        )}
      </div>
    );
  }, [loginModalVisible]);

  const isLogin = useMemo(() => {
    return !!userInfo && loginStatus === 'done';
  }, [userInfo, loginStatus]);

  const showLogin = useMemo(() => {
    if (loginStatus === 'done') {
      if (!userInfo) {
        return true;
      }
    }
    return false;
  }, [userInfo, loginStatus]);

  const openLoginModal = useCallback(() => {
    setLoginModalVisible(true);
  }, []);

  const quitLogin = useCallback(() => {
    clearUsertokenToCookie();
    window.location = '/';
  }, []);

  return {
    isLogin,
    showLogin,
    loginStatus,
    openLoginModal,
    quitLogin,
    LoginModal,
    userInfo,
  };
};
